// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"141":"contacts-page","223":"home-page","949":"authMenuItem-mui"}[chunkId] + "." + {"141":"66d53438","223":"371bcf52","949":"9f21ee9f"}[chunkId] + ".chunk.js";
};